"use client";

import React from "react";

/**
 * Keeps a snapshot of items while paused, resuming updates when unpaused.
 */
export function usePausedStream<T>(items: T[] | undefined) {
  const [paused, setPaused] = React.useState(false);
  const [visibleItems, setVisibleItems] = React.useState(items ?? []);

  const togglePaused = React.useCallback(() => {
    setPaused((value) => {
      if (!value) {
        setVisibleItems(items ?? []);
      }
      return !value;
    });
  }, [items]);

  React.useEffect(() => {
    if (paused) return;

    setVisibleItems(items ?? []);
  }, [items, paused]);

  return {
    paused,
    setPaused,
    togglePaused,
    visibleItems,
  };
}
